import { CardSubtitle } from "../../../types/CoreComponents";
import { AddressItems, BankList, CartTableBody, CartTableFooter, FormBanking, ModalOneItems, NavItems, SelectAccount, VariationBox } from "../../../types/Forms";

//two-factor
export const ModalOneData: ModalOneItems[] = [
  {
    icon: "fa-spin fa-cog",
    title: "2FA Authenticator",
    description: "Obtain codes from a authy/google authenticator/ios 15 etc.",
  },
  {
    icon: "fa-comments",
    title: "SMS",
    description: "The backup login method will be sent to you via SMS if you require it.",
  },
];

//Form Wizard 1
export const NumberingWizardSubTitle: CardSubtitle[] = [{ text: "Fill up your details and proceed next steps." }];

export const StepperHorizontalData: string[] = ["Basic Info", "Cart Info", "Feedback", "Finish"];

export const StudentValidationFormSubTitle: CardSubtitle[] = [{ text: "Please make sure fill all the filed before click on next button." }];

export const VerticalValidationWizardSubTitle: CardSubtitle[] = [{ text: "Fill up your true details and next proceed." }];

export const VerticalWizardNavData: NavItems[] = [
  {
    id: 1,
    icon: "user",
    title: "Your Info",
    subTitle: "Add your details",
  },
  {
    id: 2,
    icon: "chain-broken",
    title: "Cart Info",
    subTitle: "Add your a/c details",
  },
  {
    id: 3,
    icon: "group",
    title: "Net Banking",
    subTitle: "Choose your bank",
  },
];

export const PaymentModeName: string[] = ["Visa", "MasterCard", "paypal"];

export const NetBankingFormBankList: FormBanking[] = [
  { id: 1, bankList: ["Industrial & Commercial Bank", "Agricultural Bank", "JPMorgan Chase & Co."] },
  { id: 2, bankList: ["Construction Bank Corp.", "Bank of America", "HDFC Bank"] },
];

export const ShippingFormSubTitle: CardSubtitle[] = [{ text: "Fill up your true details and next proceed." }];

export const ShippingFormNavData: NavItems[] = [
  {
    id: 1,
    icon: "user",
    title: "Billing",
  },
  {
    id: 2,
    icon: "truck",
    title: "Shipping",
  },
  {
    id: 3,
    icon: "money",
    title: "Payment",
  },
  {
    id: 4,
    icon: "check-square",
    title: "Finish",
  },
];

export const CurrentCartTableFooterData: CartTableFooter[] = [
  { footerTittle: "Sub Total :", price: "1284.00" },
  { footerTittle: "Discount :", price: "20.00" },
  { footerTittle: "Shipping Charge :", price: "100.78" },
  { footerTittle: "Tax :", price: "205.34" },
  { footerTittle: "Total (USD) :", price: "1569.7" },
];

export const CurrentCartTableBodyData: CartTableBody[] = [
  {
    imagePath: "product/13.png",
    productName: "T-shirt",
    productSum: "$98 * 2",
    price: "$400",
  },
  {
    imagePath: "email-template/4.png",
    productName: "Headphone",
    productSum: "$4*2",
    price: "$450",
  },
  {
    imagePath: "product/2.png",
    productName: "T-shirt ",
    productSum: "$10*2",
    price: "$234",
  },
  {
    imagePath: "product/10.png",
    productName: "Chairs ",
    productSum: "$98*2",
    price: "$200",
  },
];

export const CountryData: string[] = ["Select Country", "Africa", "India", "Indonesia", "Netherlands", "U.K", "U.S"];

export const HomeAndOfficeAddressData: AddressItems[] = [
  {
    value: "shipping-choose1",
    label: "Home",
    name: "Filomena Green ",
    address: "2211 Fruitville Rd, Sarasota, Florida, US 34237",
    contact: "(941) 321-5643",
  },
  {
    value: "shipping-choose2",
    label: "Work",
    name: "Ms. Ila Runte DDS",
    address: " 1531 E 23rd St S, Independence, Mississippi, US 64055",
    contact: "(816) 252-4500",
    check: "checked",
  },
];

export const ShippingMethodsData: AddressItems[] = [
  {
    value: "standardDelivery",
    label: "Standard Delivery - Free",
    details: "Estimated 5-7 days shipping",
  },
  {
    value: "expressDelivery",
    label: "Express Delivery - $24",
    details: "Estimated 1-2 days shipping",
    check: "checked",
  },
];

//form wizard 2
export const CustomNavData: NavItems[] = [
  { id: 1, icon: "user", title: "Personal info" },
  { id: 2, icon: "chain-broken", title: "Connect bank account" },
  { id: 3, icon: "group", title: "Inquiries" },
  { id: 4, icon: "group", title: "Completed " },
];

export const PopularBanksList: BankList[] = [
  { image: "hdfc.png", bankName: "ABC BANK" },
  { image: "Bank-of-Baroda.png", bankName: "XYZ BANK" },
  { image: "idbi.png", bankName: "PQR BANK" },
  { image: "rbl.png", bankName: "DEF BANK" },
  { image: "us-bank.png", bankName: "MNO BANK" },
  { image: "axis.png", bankName: "WXY BANK" },
  { image: "SCB.png", bankName: "STD BANK" },
];

export const ItemsNameList: string[] = ["Featured Items", "Newsletters", "Notifications", "Blogs"];

export const BusinessNavData: NavItems[] = [{ id: 1, title: "Choose account" }, { id: 2, title: "Business settings" }, { id: 3, title: "Contact details" }, { id: 4, title: "Pay details" }, { id: 5, title: "completed" }];

export const SelectAccountTypeData: SelectAccount[] = [
  { icon: "university", title: "Business" },
  { icon: "user", title: "Personal " },
];

export const ListOfYears: number[] = [2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035];

export const VariationBoxData: VariationBox[] = [
  { title: "Tivo", details: "2-3 Members" },
  { title: "Zono", details: "4-5 Members" },
  { title: "Multikart", details: "2 Member" },
  { title: "Roxo", details: "1 Member" },
];
